/* src/app/components/advertizing-impression/advertizing-impression.component.scss */
.full-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 20;
  top: 0;
  left: 0;
  color: white;
}
.advertizing-impression {
  position: absolute;
  z-index: 10;
  align-self: center;
  width: 100%;
}
.advertizing-impression ion-img {
  margin-left: 0px;
  align-self: center;
  margin-left: 10vmin;
  max-width: 80vmin;
  max-height: 400px;
}
.advertizing-impression ion-buttons {
  text-align: center;
  margin-top: 10vmin;
  margin-left: 10vmin;
  margin-right: 10vmin;
  font-size: large;
  display: flex;
  justify-content: end;
}
.advertizing-impression ion-buttons a {
  font-size: larger;
}
@media (min-width: 768px) {
  .advertizing-impression-flex {
    display: flex;
  }
}
@media (min-width: 768px) {
  .advertizing-impression-block {
    display: block;
  }
}
ion-button {
  --background: var(--ion-color-primary) !important;
  color: var(--ion-color-inverted-text);
}
.btn-external {
  width: 90%;
}
.button-text,
.bottom-button-text {
  text-align: unset !important;
  margin-top: unset !important;
  margin-left: unset !important;
  margin-right: unset !important;
  font-size: unset !important;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: min-content;
  position: static;
  color: var(--ion-color-inverted-text);
}
.button-text {
  padding: 0 0.75rem;
}
.bottom-button-text {
  width: 100%;
  text-wrap: auto;
}
ion-icon {
  padding-left: 0.75rem;
}
.description {
  margin: 0;
  padding: 1rem 0.5rem;
}
.button-content-container {
  display: grid;
  grid-template-columns: 1fr 6fr 1fr;
  align-items: center;
}
/*# sourceMappingURL=advertizing-impression.component.css.map */
